if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}

if (!customElements.get('custom-product-modal')) {
  customElements.define(
    'custom-product-modal',
    class CustomProductModal extends ModalDialog {
      constructor() {
        super();
        this.addEventListener('click', (event) => {
          if(event.target.classList.contains('product-modal-close') || event.target.closest('.product-modal-close') != null) {
            super.hide();
          }
          if (event.target == this) {
            super.hide();
          }
        });
      }

      hide() {
        return true;
      }

      show(opener) {
        super.show(opener);
        const mediaId = this.openedBy?.getAttribute('data-media-id');
        const slideIndexAttr = this.openedBy?.getAttribute('data-slide-index');
        
        const allSlides = this.querySelectorAll('.slideshow__slide, .swiper-slide');
        
        // Find the slide index by media-id
        let targetSlideIndex = -1;
        allSlides.forEach((slide, idx) => {
          const slideMediaId = slide.getAttribute('data-media-id');
          // Try exact match first
          if (slideMediaId === mediaId) {
            targetSlideIndex = idx;
          }
          // Try partial match (mediaId might be with or without section prefix)
          else if (mediaId && slideMediaId && (
            slideMediaId.endsWith(mediaId) || 
            mediaId.endsWith(slideMediaId) ||
            slideMediaId.includes(mediaId.split('-').pop()) ||
            mediaId.includes(slideMediaId.split('-').pop())
          )) {
            if (targetSlideIndex === -1) {
              targetSlideIndex = idx;
            }
          }
        });
        
        // Fallback to slide-index attribute if no match found
        if (targetSlideIndex === -1 && slideIndexAttr) {
          const parsedIndex = parseInt(slideIndexAttr, 10) - 1; // slide-index is 1-based
          if (parsedIndex >= 0 && parsedIndex < allSlides.length) {
            targetSlideIndex = parsedIndex;
          }
        }
        
        // Default to first slide if nothing found
        if (targetSlideIndex === -1) {
          targetSlideIndex = 0;
        }

        
        const slideshowComponent = this.querySelector('slideshow-component');
        const slider = slideshowComponent?.querySelector('.slider, .slideshow');
        
        if (slider && allSlides.length > 0) {
          // Calculate scroll position based on slide width
          const slideWidth = allSlides[0].offsetWidth;
          const scrollPosition = targetSlideIndex * slideWidth;
          
          // Scroll to the correct position
          slider.scrollTo({
            left: scrollPosition,
            behavior: 'instant'
          });
          
          // Update slideshow component's currentPage
          if (slideshowComponent) {
            slideshowComponent.currentPage = targetSlideIndex + 1;
          }
          
          // Update counter if exists
          const counterCurrent = this.querySelector('.slider-counter--current');
          if (counterCurrent) {
            counterCurrent.textContent = (targetSlideIndex + 1).toString();
          }
          
          // Update total counter to actual number of slides
          const counterTotal = this.querySelector('.slider-counter--total');
          if (counterTotal) {
            counterTotal.textContent = allSlides.length.toString();
          }
        }
      }
    }
  );
}
